import { createClient } from '@supabase/supabase-js'

const supabaseUrl =  'https://pkpwiwbitfrhrozmsofj.supabase.co'
const supabaseKey = 'sb_publishable_8TKF-YbQ4CYwT8k8GuRctg_aOart8R7'

export const supabase = createClient(supabaseUrl, supabaseKey)